import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { logoutUser } from '../actions/formActions';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const Topbar = ({ auth, logoutUser }: any) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const onLogoutClick = () => {
    let cartItems = JSON.parse(localStorage.getItem('shopping_cart'));
    if (cartItems) {
      cartItems = [];
      localStorage.setItem('shopping_cart', JSON.stringify(cartItems));
    }

    logoutUser();
    history.push('/login');
  };

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const { isAuthenticated } = auth;
  const { user } = auth;

  const guestLinks = (
    <React.Fragment>
      <span className="float-right pr-3 pl-3 pt-2  " style={{ fontSize: 14 }}>
        <a href="/login" className="login">
          <i className="fas fa-key pr-1" style={{ color: 'rgb(236,23,79)', fontSize: 12 }}></i>{' '}
          Login
        </a>
      </span>
      <span className="float-right pt-2 " style={{ fontSize: 14 }}>
        <a href="/signup" className="signup">
          <i
            className="fas fa-user-plus pr-1"
            style={{ color: 'rgb(236,23,79)', fontSize: 12 }}
          ></i>
          Sign up
        </a>
      </span>
    </React.Fragment>
  );

  const authLinks = (
    <React.Fragment>
      <Dropdown
        style={{ right: 10 }}
        size="sm"
        isOpen={dropdownOpen}
        toggle={toggle}
        className="  position-absolute"
      >
        <DropdownToggle tag="span">
          <span style={{ cursor: 'pointer', color: 'rgb(236,23,79)' }}>
            <i className="fas fa-user pr-1 " style={{ fontSize: '13px' }}></i>
            {user.firstName}
            <i className="fas fa-caret-down pl-2" style={{ fontSize: '15px' }}></i>
          </span>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => history.push('/dashboard')}>Profile</DropdownItem>
          <DropdownItem onClick={() => history.push('/cart')}>Checkout</DropdownItem>
          <DropdownItem onClick={onLogoutClick}>Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );

  return (
    location.pathname !== '/checkout' &&
    location.pathname !== '/adminpanel' && (
      <div className="" style={{ fontSize: 18, lineHeight: 1, backgroundColor: 'white' }}>
        <div className="topbar ">{isAuthenticated ? authLinks : guestLinks}</div>
      </div>
    )
  );
};

const mapStateToProps = (state: any) => ({
  auth: state.form,
});

export default connect(mapStateToProps, { logoutUser })(Topbar);
